export default __webpack_public_path__ + "static/media/img9.e271ca5a.png";